/** Предпросмотр: сколько строк накладной показывать на экране. */
export const PREVIEW_LIMIT = 50

/** Байт в КиБ и в МиБ — для подписи размера загруженного файла. */
export const BYTES_PER_KIB = 1024
export const BYTES_PER_MIB = BYTES_PER_KIB * 1024

/** Виды попыток команд импорта: от вида зависит ключ идемпотентности (`attemptKey`). */
export type AttemptKind = 'profile' | 'mapping' | 'validate' | 'delete'
